export const MAX_PROJECTS_PER_USER = 10;
export const ADMIN_EMAILS = ['enghishamreda@gmail.com'];

export function normalizeEmail(email) {
  return String(email || '').trim().toLowerCase();
}

export function isAdminEmail(email) {
  return ADMIN_EMAILS.includes(normalizeEmail(email));
}
